import {useAuthState} from '../utils/AuthContext'

export const useAuth = () => useAuthState()
